<template>
  <div class="stock-view">
    <div class="grid-row">
      <div class="column">
        <h1>{{$_('stock_consultation')}}</h1>
        <p>{{$_('stock_consultation_text')}}</p>
      </div>
    </div>
    <div class="grid-row">
      <div class="column">
        <StockResearch />
      </div>
    </div>
    <div class="grid-row">
      <div class="column">
        <StockList />
      </div>
    </div>
    <div class="grid-row">
      <div class="column"></div>
    </div>
  </div>
</template>

<script>
import StockResearch from "@/modules/stock/components/StockResearch";
import StockList from "@/modules/stock/components/StockList";

export default {
  name: "StockView",
  components: {
    StockResearch,
    StockList
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}
</style>